<script>
  import projetoServico from '~modulos/projeto/servico';

  import 'select2';
  import 'select2/dist/js/i18n/pt-BR';
  
  export default {
    data() {
      return {
        idProjeto: '',
        projetos: [],
        configuracao: this.$storage.configuracao(),
        projeto: {
          nomeProjeto: '',
          codigoProjetoSimples: '',
          codigoProjetoCompleto: '',
          codigoUnidade: '',
          codigoDepartamentoSimples: '',
          nomeCoordenador: '',
          nomeViceCoordenador: '',
          nomeUnidade: '',
          nomeDepartamento: '',
          dataInicio: '',
          dataTermino: '',
          dataInicioVigencia: '',
          dataTerminoVigencia: '',
          dataLimiteSolicitacao: '',
          dataLimiteSolicitacaoCompra: '',
          dataLimiteSolicitacaoReembolso: '',
          siconv: '',
          tituloProjeto:'',
        },
        carregando: false,
      }
    },
    methods: {
      listaDeProjetos() {
        return projetoServico
          .listaDeProjetos()
          .then(projetos => {
            this.projetos = projetos;
          });
      },
      imformacoesProjeto(idProjeto) {
        this.carregando = true;
        
        return projetoServico
          .informacoes(idProjeto)
          .then(projeto => {
            this.projeto = projeto;
            this.carregando = false;
          })
          .catch(erro => {
            this.carregando = false;
            this.idProjeto = 0;

            if (erro.status === 422) { 
              this.$swal('', erro.body.message, 'error');
            } else{
              this.$swal('', 'Ocorreu um erro ao buscar informações do projeto, caso o erro persista entre em contato com a fundação.', 'error');
            }
          });
      }
    },
    mounted() {
      this.$root.tituloDaPagina = `Informações do Projeto`;
      this.$root.botaoAcaoMostrar = false;

      this.$root.botaoRetrocederMostrar = false;
      this.$root.botaoRetrocederRota = '';

      this.listaDeProjetos();

      const _this = this;

      $('#projeto').select2({
        theme: "bootstrap",
        placeholder: "Selecione...",
        language: "pt-BR"
      })
      .change(function(e) {
        _this.$set(_this, 'idProjeto', this.value);
        
        _this.imformacoesProjeto(this.value);
      });
    },
    computed: {
      periodoDeVigencia() {
        let dataInicio = this.projeto.dataInicioVigencia;
        let dataTermino = this.projeto.dataTerminoVigencia;

        if (!dataInicio && !dataTermino) {
          return '---';
        }
        
        let data = this.$options.filters.formatarData(dataInicio);
        
        if (dataTermino) {
          data += ' - ' + this.$options.filters.formatarData(dataTermino);
        }
        
        return data;
      },
      periodoDeExecucao() {
        let dataInicio = this.projeto.dataInicio;
        let dataTermino = this.projeto.dataTermino;

        if (!dataInicio && !dataTermino) {
          return '---';
        }

        let data = this.$options.filters.formatarData(dataInicio);

        if (dataTermino) {
          data += ' - ' + this.$options.filters.formatarData(dataTermino);
        }

        return data;
      },
    },
  }
</script>

<template>
  <div :class="['wrapper wrapper-content animated', $root.animacaoPadrao]">

    <div class="row">
      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-content">

            <div class="row">
              <div class="col-xs-12">
                <div class="form-group">
                  <label class="control-label" for="projeto">Projeto</label>

                  <select
                    id="projeto"
                    class="form-control"
                    v-model="idProjeto">
                    <option
                      :value="projeto.idProjeto"
                      v-for="(projeto, index) in projetos">
                      {{ projeto.nomeProjeto }}
                    </option>
                  </select>
                </div>
              </div>
            </div>

            <p v-show="carregando" class="text-center">
              <i class='fa fa-spinner fa-pulse'></i> Carregando...
            </p>

            <div v-if="!carregando && idProjeto">

              <div class="row">
                <dl class="col-xs-10">
                  <dt>Nome/identificação</dt>
                  <dd>{{ projeto.nomeProjeto }}</dd>
                </dl>
                <dl class="col-xs-2">
                  <dt>Código</dt>
                  <dd>{{ projeto.codigoProjetoCompleto || '---' }}</dd>
                </dl>
              </div>

              <div class="row">
                <dl class="col-xs-12">
                  <dt>Título projeto</dt>
                  <dd>{{ projeto.tituloProjeto || '---' }}</dd>
                </dl>
              </div>

              <div class="row">
                <dl class="col-xs-5">
                  <dt>Unidade</dt>
                  <dd>{{ projeto.nomeUnidade || '---' }}</dd>
                </dl>
                <dl class="col-xs-1">
                  <dt>Código</dt>
                  <dd>{{ projeto.codigoUnidade || '---' }}</dd>
                </dl>
                <dl class="col-xs-5">
                  <dt>Departamento</dt>
                  <dd>{{ projeto.nomeDepartamento || '---' }}</dd>
                </dl>
                <dl class="col-xs-1">
                  <dt>Código</dt>
                  <dd>{{ projeto.codigoDepartamentoSimples || '---' }}</dd>
                </dl>
              </div>

              <div class="row">
                <dl class="col-xs-6">
                  <dt>Coordenador</dt>
                  <dd>{{ projeto.nomeCoordenador || '---' }}</dd>
                </dl>
                <dl class="col-xs-6">
                  <dt>{{ this.configuracao.nomeResponsavel ? this.configuracao.nomeResponsavel : "Responsável" }}</dt>
                  <dd>{{ projeto.nomeViceCoordenador || '---' }}</dd>
                </dl>
              </div>

              <div class="row">
                <dl class="col-xs-5">
                  <dt>Período de execução</dt>
                  <dd>{{ periodoDeExecucao }}</dd>
                </dl>
                <dl class="col-xs-5">
                  <dt>Período de vigência</dt>
                  <dd>{{ periodoDeVigencia }}</dd>
                </dl>
                <dl class="col-xs-2">
                  <dt>SICONV</dt>
                  <dd>{{ projeto.siconv ? 'Sim' : 'Não' }}</dd>
                </dl>
              </div>

              <h3 class="m-t-none m-b">Data limite para solicitações</h3>

              <div class="hr-line-dashed margin-top-5"></div>

              <div class="row">

                <dl class="col-xs-1">
                  <dt>Adiantamento</dt>
                  <dd>{{ projeto.dataLimiteSolAdiantamento | formatarData('---') }}</dd>
                </dl>

                <dl class="col-xs-2">
                  <dt>Bolsa, RPA ou estágio</dt>
                  <dd>{{ projeto.dataLimiteSolBolsaRpaEstagio | formatarData('---') }}</dd>
                </dl>

                <dl class="col-xs-2">
                  <dt>Compra</dt>
                  <dd>{{ projeto.dataLimiteSolicitacaoCompra | formatarData('---') }}</dd>
                </dl>

                <dl class="col-xs-2">
                  <dt>Passagem, diária e adiantamento</dt>
                  <dd>{{ projeto.dataLimiteSolicitacaoReembolso | formatarData('---') }}</dd>
                </dl>

                <dl class="col-xs-2">
                  <dt>Pagamento</dt>
                  <dd>{{ projeto.dataLimiteSolicitacao | formatarData('---') }}</dd>
                </dl>

                <dl class="col-xs-2">
                  <dt>Faturamento</dt>
                  <dd>{{ projeto.dataLimiteSolFaturamento | formatarData('---') }}</dd>
                </dl>

                <dl class="col-xs-1">
                  <dt>Reembolso terceiro</dt>
                  <dd>{{ projeto.dataLimiteSolReembolsoTerceiro | formatarData('---') }}</dd>
                </dl>

              </div>

              <div class="hr-line-dashed margin-top-5"></div>

            </div>
            
          </div>
        </div>
      </div>
    </div>
    
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/projeto/componentes/Projeto.vue